import {useEffect} from 'react'
import {useGameStore} from '../store/GameStoreContext'
import {StorageWrapper} from '../utils/storage'

export const useGameUserSettingsStorage = () => {
    const volume = useGameStore((state) => state.gameUserSettings.volume)
    const isAnimationsEnabled = useGameStore((state) => state.gameUserSettings.isAnimationsEnabled)
    const isKeyboardShortcutsEnabled = useGameStore((state) => state.gameUserSettings.isKeyboardShortcutsEnabled)
    const isAntialiasEnabled = useGameStore((state) => state.gameUserSettings.isAntialiasEnabled)
    const resolution = useGameStore((state) => state.gameUserSettings.resolution)
    const powerPreference = useGameStore((state) => state.gameUserSettings.powerPreference)

    useEffect(() => {
        StorageWrapper.setMasterVolume(volume)
    }, [volume])

    useEffect(() => {
        StorageWrapper.setAnimation(isAnimationsEnabled)
    }, [isAnimationsEnabled])

    useEffect(() => {
        StorageWrapper.setKeyboardShortcuts(isKeyboardShortcutsEnabled)
    }, [isKeyboardShortcutsEnabled])

    useEffect(() => {
        StorageWrapper.setAntialias(isAntialiasEnabled)
    }, [isAntialiasEnabled])

    useEffect(() => {
        StorageWrapper.setResolution(resolution)
    }, [resolution])

    useEffect(() => {
        StorageWrapper.setPowerPreference(powerPreference)
    }, [powerPreference])
}
